/** Shared between the app and the service worker. */
export const OUTBOX_SYNC_TAG = 'mezsites-outbox'
export const OUTBOX_FLUSH_MESSAGE = 'OUTBOX_FLUSH'
